<script>
export default {
  name: 'NairaSignIcon',
  functional: true,
  props: {
    size: {
      type: [String, Number],
      default: '14',
    },
  },
  render(h, { props, data }) {
    return h(
      'svg',
      {
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          width: props.size,
          height: props.size,
          viewBox: '0 0 640 640',
          fill: 'currentColor',
        },
        class: ['naira-icon', data.class, data.staticClass],
        style: data.style,
        on: data.on,
      },
      [
        h('path', {
          attrs: {
            d: 'M218.6 110.3C210.8 98.6 196.2 93.3 182.7 97.4C169.2 101.5 160 113.9 160 128L160 320L128 320C114.7 320 104 330.7 104 344C104 357.3 114.7 368 128 368L160 368L160 512C160 529.7 174.3 544 192 544C209.7 544 224 529.7 224 512L224 368L313.5 368L421.3 529.8C429.1 541.5 443.7 546.8 457.2 542.7C470.7 538.6 480 526.1 480 512L480 368L512 368C525.3 368 536 357.3 536 344C536 330.7 525.3 320 512 320L480 320L480 128C480 110.3 465.7 96 448 96C430.3 96 416 110.3 416 128L416 320L358.5 320L218.7 110.3zM390.5 368L416 368L416 406.3L390.5 368zM281.5 320L224 320L224 233.7L281.5 320z',
          },
        }),
      ],
    )
  },
}
</script>

<style lang="scss">
.naira-icon {
  outline: none;
  vertical-align: middle;
}
</style>
